import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const containerStyle = {
  width: '100%',
  height: '400px',
};

const SimpleMap = ({ userLocation, className = "", onSelectLocation }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });
  const [selected, setSelected] = React.useState(userLocation);
  const [address, setAddress] = React.useState("");

  React.useEffect(() => {
    setSelected(userLocation);
  }, [userLocation]);

  const reverseGeocode = async (lat, lng) => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      if (data.status === "OK" && data.results.length > 0) {
        return data.results[0].formatted_address;
      }
    } catch (e) {}
    return "";
  };

  const handleMapClick = React.useCallback(async (e) => {
    if (onSelectLocation && e.latLng) {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setSelected({ lat, lng });
      const addr = await reverseGeocode(lat, lng);
      setAddress(addr);
      onSelectLocation({ lat, lng, address: addr });
    }
  }, [onSelectLocation]);

  if (!userLocation) {
    return (
      <div className={`bg-gray-100 rounded-lg p-8 text-center ${className}`}>
        <p className="text-gray-600 mb-2">Location access required</p>
        <p className="text-sm text-gray-500">Please allow location access to view the map</p>
      </div>
    );
  }

  if (loadError) {
    return <div className="text-red-500">Failed to load Google Maps</div>;
  }

  return (
    <div className={`bg-white border border-gray-200 rounded-lg shadow-lg overflow-hidden ${className}`}>
      <div className="p-3 border-b border-gray-200 bg-gray-50 flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">Your Location</span>
      </div>
      <div className="relative h-64">
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={selected || userLocation}
            zoom={15}
            onClick={onSelectLocation ? handleMapClick : undefined}
          >
            {(selected || userLocation) && (
              <Marker position={selected || userLocation} />
            )}
          </GoogleMap>
        ) : (
          <div className="flex items-center justify-center h-full bg-gray-100">
            <div className="text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
              <p className="text-sm text-gray-600">Loading map...</p>
            </div>
          </div>
        )}
      </div>
      <div className="p-3 bg-gray-50">
        <div className="flex items-center justify-between">
          <div className="text-xs text-gray-600">
            📍 {selected ? `${selected.lat.toFixed(6)}, ${selected.lng.toFixed(6)}` : ''}
          </div>
        </div>
      </div>
      {address && (
        <div className="mt-2 text-sm text-gray-700">{address}</div>
      )}
    </div>
  );
};

export default SimpleMap; 